import { render, staticRenderFns } from "./cascader.vue?vue&type=template&id=01a06d9a&scoped=true"
import script from "./cascader.vue?vue&type=script&lang=js"
export * from "./cascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a06d9a",
  null
  
)

export default component.exports